import { Form } from "../helpers/form";
HTMLFormElement.prototype.inputs = function () {
    return Form.inputs(this);
};
HTMLFormElement.prototype.serializeObject = function (includeData) {
    return Form.serializeObject(this, includeData);
};
